import React from 'react'
import PropTypes from 'prop-types'
import { Col, Container, Row } from 'react-bootstrap'
import dynamic from 'next/dynamic'

import queryGraphql from '@shared/components/queryGraphql'
import Layout from '@shared/components/layout'
import { GET_SEO_DATA } from '@graphql//article/article.query'
import { LIST_SERIES_TEAMS } from '@graphql/series/teams.query'
import { FIXTURES_LIST, FETCH_TEAM_VENUE } from '@graphql/series/fixtures.query'
import { GET_STANDING_DATA } from '@graphql/series/standings.query'
import { FETCH_SERIES_STATS_TYPE, STATS, MATCH_TYPES } from '@graphql/series/stats.query'
import { pageHeaderLoader } from '@shared/libs/allLoader'
import { allRoutes } from '@shared-submodule/sm-constants/allRoutes'
import { GET_SERIES_BY_ID } from '@graphql/cricket-series/cricket-series.query'
import { GET_TEAM_PLAYER } from '@graphql/series/squads.query'
import { arraySortByOrder, checkRedirectionStatus, handleApiError, parallelCalls } from '@shared-submodule/utils'
import { LIST_SERIES_FANTASY_TIPS } from '@graphql/series/fantasy-tips.query'
import { SERIES_MINI_SCORECARD } from '@graphql/home/home.query'
import Error from '@shared/components/error'
import { ENUM_CRICKET_SERIES_PAGES, ENUM_SEO_SUBTYPE } from '@shared-submodule/sm-enum'
import { GET_SUB_PAGE_BY_SLUG } from '@graphql/seo/seo.query'
import { CURRENT_SERIES_LIST, RANKINGS } from '@graphql/globalwidget/rankings.query'
import LazyLoad from '@shared/components/lazyLoad'

const RankingTab = dynamic(() => import('@shared/components/rankingTab'))
const CurrentSeries = dynamic(() => import('@shared/components/widgets/currentSeries'))
const CategoryMain = dynamic(() => import('@shared/components/categoryMain'))
const Fixtures = dynamic(() => import('@shared/components/series/fixtures'))
const CommonNav = dynamic(() => import('@shared/components/commonNav'))
const Standings = dynamic(() => import('@shared/components/series/standings'))
const Stats = dynamic(() => import('@shared/components/series/stats'))
const SeriesTeam = dynamic(() => import('@shared/components/series/seriesTeam'))
const PageHeader = dynamic(() => import('@shared/components/pageHeader'), { loading: () => pageHeaderLoader() })
const SeriesSquads = dynamic(() => import('@shared/components/series/seriesSquads'))
const UpcomingMatches = dynamic(() => import('@shared/components/widgets/upcomingMatches'))
// const SeriesFantasyTipsList = dynamic(() => import('@shared/components/series/seriesFantasyTipsList'))
const ATSAds = dynamic(() => import('@shared/components/atsAds'), { ssr: false })

const SeriesPage = props => {
  const {
    seoData,
    fixturesData,
    fixturesFilter,
    roundData,
    standingData,
    type,
    seriesData,
    statsData,
    seriesTeamData,
    seriesHeaderData,
    teamPlayer,
    matchTypeData,
    // seriesFantasyTipsData,
    subPages = [],
    scoreCard,
    category,
    currentSeriesData,
    rankingTabData,
    statsDataBattingMostRuns,
    statsDataBattingHighestStrikerate,
    statsDataBattingHighestAverage,
    statsDataBowlingTopWickeTakers,
    statsDataBowlingBestEconomy,
    statsDataBowlingBestAverages
  } = props
  const tab = () => {
    if (type === 'standings') {
      return <Standings round={roundData?.fetchSeriesRounds} id={seoData?.iId} standing={standingData?.fetchSeriesStandings} />
    } else if (type === 'stats') {
      return (
        <Stats
          data={statsData}
          typeData={seriesData}
          id={seoData?.iId}
          matchTypeData={matchTypeData?.listSeriesStatsFormat}
          statsDataBattingMostRuns={statsDataBattingMostRuns}
          statsDataBattingHighestStrikerate={statsDataBattingHighestStrikerate}
          statsDataBattingHighestAverage={statsDataBattingHighestAverage}
          statsDataBowlingTopWickeTakers={statsDataBowlingTopWickeTakers}
          statsDataBowlingBestEconomy={statsDataBowlingBestEconomy}
          statsDataBowlingBestAverages={statsDataBowlingBestAverages}
        />
      )
    } else if (type === 'teams') {
      return <SeriesTeam data={seriesTeamData} id={seoData?.iId} />
    } else if (type === 'squads') {
      return <SeriesSquads team={seriesTeamData?.listSeriesTeams?.aTeams} players={teamPlayer} id={seoData?.iId} />
    } else {
      return <Fixtures data={fixturesData} teamVenueData={fixturesFilter} id={seoData?.iId} />
    }
    // else if (type === 'fantasy-tips') {
    //   return <SeriesFantasyTipsList data={seriesFantasyTipsData} id={seoData?.iId} />
    // }
  }

  function getNavItems() {
    const items = []
    subPages.forEach(t => {
      if (ENUM_CRICKET_SERIES_PAGES[t?.eSubType] && t?.eSubType !== 'ft') {
        items.push({
          navItem: ENUM_CRICKET_SERIES_PAGES[t?.eSubType].replaceAll(/-/gi, ' '),
          url: `/${t?.sSlug}`,
          active: t?.eSubType === seoData?.eSubType
        })
      } else if (t?.eSubType === null) {
        // Home Tab
        items.push({
          navItem: ENUM_CRICKET_SERIES_PAGES.f.replaceAll(/-/gi, ' '),
          url: `/${t?.sSlug}`,
          active: t?.eSubType === seoData?.eSubType
        })
      }
    })
    const order = ['fixtures', 'standings', 'stats', 'squads', 'fantasy tips']
    return arraySortByOrder({ data: items, order, key: 'navItem' })
  }

  if (seoData?.eType === 'ct') {
    return (
      <>
        <CategoryMain category={category} seoData={seoData} currentSeriesData={currentSeriesData} rankingTabData={rankingTabData} />
      </>
    )
  } else {
    return (
      <Layout data={{ oSeo: seoData }} scoreCard={scoreCard}>
        <main>
          {/* <ScorecardSlider data={scoreCard} seriesId={seriesHeaderData?._id} /> */}
          <div className="common-section pt-4">
            <ATSAds />
            <Container>
              <Row>
                <Col lg={9} className="left-content">
                  <PageHeader name={seriesHeaderData?.sTitle} showHeaderImg={seoData?.eType === 'se'} isSeries />
                  <div className="mt-3">
                    <CommonNav items={getNavItems()} />
                  </div>
                  {tab()}
                </Col>
                <Col lg={3} className="common-sidebar">
                  <UpcomingMatches />
                  <ATSAds />
                  <LazyLoad>
                    <RankingTab dataSSR={rankingTabData} />
                    <CurrentSeries dataSSR={currentSeriesData} />
                  </LazyLoad>
                </Col>
              </Row>
            </Container>
          </div>
        </main>
      </Layout>
    )
  }
}

SeriesPage.propTypes = {
  seoData: PropTypes.object,
  fixturesData: PropTypes.object,
  fixturesFilter: PropTypes.object,
  type: PropTypes.string,
  roundData: PropTypes.object,
  standingData: PropTypes.object,
  seriesData: PropTypes.object,
  statsData: PropTypes.object,
  seriesTeamData: PropTypes.object,
  seriesArchivesData: PropTypes.object,
  error: PropTypes.any,
  seriesHeaderData: PropTypes.object,
  matchTypeData: PropTypes.object,
  teamPlayer: PropTypes.array,
  seriesFantasyTipsData: PropTypes.object,
  subPages: PropTypes.array,
  scoreCard: PropTypes.array,
  category: PropTypes.object,
  currentSeriesData: PropTypes.object,
  rankingTabData: PropTypes.object,
  statsDataBattingMostRuns: PropTypes.object,
  statsDataBattingHighestStrikerate: PropTypes.object,
  statsDataBattingHighestAverage: PropTypes.object,
  seo: PropTypes.object,
  statsDataBowlingTopWickeTakers: PropTypes.object,
  statsDataBowlingBestEconomy: PropTypes.object,
  statsDataBowlingBestAverages: PropTypes.object
}

export default Error(SeriesPage)

export async function getServerSideProps({ res, params, resolvedUrl, query }) {
  const slug = params?.slug?.join('/')

  try {
    res.setHeader('Cache-Control', 'public, max-age=420')
    const [idData, currentSeriesData] = await parallelCalls([
      queryGraphql(GET_SEO_DATA, { input: { sSlug: `${allRoutes.cricketSeriesNew.slice(1)}/${slug}` } }),
      queryGraphql(CURRENT_SERIES_LIST)
    ])
    const currentPage = ENUM_SEO_SUBTYPE[idData?.getSeoData?.eSubType]
    // Check Redirection
    const { redirectStatus, eCode, returnObj, props } = checkRedirectionStatus(idData?.getSeoData)
    if (redirectStatus && props) {
      res.statusCode = eCode
      return { props }
    } else if (redirectStatus) return returnObj

    if (idData?.getSeoData?.eType === 'se') {
      // For series only
      const [seriesHeaderData, subPages, scoreCard, rankingTabData] = await parallelCalls([
        queryGraphql(GET_SERIES_BY_ID, { input: { _id: idData?.getSeoData?.iId } }),
        queryGraphql(GET_SUB_PAGE_BY_SLUG, { input: { sSlug: idData?.getSeoData?.sSlug } }),
        queryGraphql(SERIES_MINI_SCORECARD, { input: { _id: idData?.getSeoData?.iId } }),
        queryGraphql(RANKINGS, {
          input: { eMatchType: 'Tests', eRankType: 'Teams', nLimit: 5, nSkip: 0 }
        })
      ])

      if (currentPage === 'standings') {
        // const { data: roundData } = await queryGraphql(GET_ROUNDS, { input: { iSeriesId: idData?.getSeoData?.iId } })
        // disabled round data api because its causing trouble showing roundwise filter data, closing this api temporarily.
        const { data: standingData } = await queryGraphql(GET_STANDING_DATA, {
          input: { iRoundId: null, iSeriesId: idData?.getSeoData?.iId }
        })
        return {
          props: {
            seoData: idData?.getSeoData,
            roundData: [],
            standingData: standingData,
            seriesHeaderData: seriesHeaderData?.getSeriesByIdFront,
            type: currentPage,
            scoreCard: scoreCard?.listSeriesScorecard,
            subPages: subPages?.getSeosBySlug,
            currentSeriesData: currentSeriesData,
            rankingTabData: rankingTabData
          }
        }
      } else if (currentPage === 'stats') {
        const { data: seriesData } = await queryGraphql(FETCH_SERIES_STATS_TYPE, { input: { eGroupTitle: 'All' } })

        // Get stats data base on selected filter
        let currentItemData
        if (idData?.getSeoData?.eSubType !== 'st') {
          const lastSlug = idData?.getSeoData?.sSlug?.split('/')?.slice(-1)[0]?.replaceAll('-', '_')
          currentItemData = seriesData?.fetchSeriesStatsTypes.filter(i => {
            const slugType = i.sSeoType || i.sType
            return slugType === lastSlug
          })
        }

        if (
          seriesHeaderData?.getSeriesByIdFront?.sSeriesType === 'tour' ||
          seriesHeaderData?.getSeriesByIdFront?.sSeriesType === 'series'
        ) {
          const { data: matchTypeData } = await queryGraphql(MATCH_TYPES, { input: { iSeriesId: idData?.getSeoData?.iId } })
          const { data: statsData } = await queryGraphql(STATS, {
            input: {
              iSeriesId: idData?.getSeoData?.iId,
              _id: idData?.getSeoData?.eSubType !== 'st' ? currentItemData[0]._id : seriesData?.fetchSeriesStatsTypes[0]?._id,
              eFormat: matchTypeData?.listSeriesStatsFormat[0]
            }
          })
          // Batting
          const battingMostRuns = seriesData.fetchSeriesStatsTypes.find(obj => obj.sType === 'batting_most_runs')
          const { data: statsDataBattingMostRuns } = await queryGraphql(STATS, {
            input: { iSeriesId: idData?.getSeoData?.iId, _id: battingMostRuns._id }
          })
          const battingHighestStrikerate = seriesData.fetchSeriesStatsTypes.find(obj => obj.sType === 'batting_highest_strikerate')
          const { data: statsDataBattingHighestStrikerate } = await queryGraphql(STATS, {
            input: { iSeriesId: idData?.getSeoData?.iId, _id: battingHighestStrikerate._id }
          })
          const battingHighestAverage = seriesData.fetchSeriesStatsTypes.find(obj => obj.sType === 'batting_highest_average')
          const { data: statsDataBattingHighestAverage } = await queryGraphql(STATS, {
            input: { iSeriesId: idData?.getSeoData?.iId, _id: battingHighestAverage._id }
          })
          // Bowling
          const bowlingTopWickeTakers = seriesData.fetchSeriesStatsTypes.find(obj => obj.sType === 'bowling_top_wicket_takers')
          const { data: statsDataBowlingTopWickeTakers } = await queryGraphql(STATS, {
            input: { iSeriesId: idData?.getSeoData?.iId, _id: bowlingTopWickeTakers._id }
          })
          const bowlingBestEconomy = seriesData.fetchSeriesStatsTypes.find(obj => obj.sType === 'bowling_best_economy_rates')
          const { data: statsDataBowlingBestEconomy } = await queryGraphql(STATS, {
            input: { iSeriesId: idData?.getSeoData?.iId, _id: bowlingBestEconomy._id }
          })
          const bowlingBestAverages = seriesData.fetchSeriesStatsTypes.find(obj => obj.sType === 'bowling_best_averages')
          const { data: statsDataBowlingBestAverages } = await queryGraphql(STATS, {
            input: { iSeriesId: idData?.getSeoData?.iId, _id: bowlingBestAverages._id }
          })
          return {
            props: {
              seoData: idData?.getSeoData,
              seriesData: seriesData,
              statsData: statsData,
              matchTypeData: matchTypeData,
              seriesHeaderData: seriesHeaderData?.getSeriesByIdFront,
              type: currentPage,
              scoreCard: scoreCard?.listSeriesScorecard,
              subPages: subPages?.getSeosBySlug,
              currentSeriesData: currentSeriesData,
              statsDataBattingMostRuns: statsDataBattingMostRuns,
              statsDataBattingHighestStrikerate: statsDataBattingHighestStrikerate,
              statsDataBattingHighestAverage: statsDataBattingHighestAverage,
              statsDataBowlingTopWickeTakers: statsDataBowlingTopWickeTakers,
              statsDataBowlingBestEconomy: statsDataBowlingBestEconomy,
              statsDataBowlingBestAverages: statsDataBowlingBestAverages
            }
          }
        } else {
          const { data: statsData } = await queryGraphql(STATS, {
            input: {
              iSeriesId: idData?.getSeoData?.iId,
              _id: idData?.getSeoData?.eSubType !== 'st' ? currentItemData[0]._id : seriesData?.fetchSeriesStatsTypes[0]?._id
            }
          })
          // Batting
          const battingMostRuns = seriesData.fetchSeriesStatsTypes.find(obj => obj.sType === 'batting_most_runs')
          const { data: statsDataBattingMostRuns } = await queryGraphql(STATS, {
            input: { iSeriesId: idData?.getSeoData?.iId, _id: battingMostRuns._id }
          })
          const battingHighestStrikerate = seriesData.fetchSeriesStatsTypes.find(obj => obj.sType === 'batting_highest_strikerate')
          const { data: statsDataBattingHighestStrikerate } = await queryGraphql(STATS, {
            input: { iSeriesId: idData?.getSeoData?.iId, _id: battingHighestStrikerate._id }
          })
          const battingHighestAverage = seriesData.fetchSeriesStatsTypes.find(obj => obj.sType === 'batting_highest_average')
          const { data: statsDataBattingHighestAverage } = await queryGraphql(STATS, {
            input: { iSeriesId: idData?.getSeoData?.iId, _id: battingHighestAverage._id }
          })
          // Bowling
          const bowlingTopWickeTakers = seriesData.fetchSeriesStatsTypes.find(obj => obj.sType === 'bowling_top_wicket_takers')
          const { data: statsDataBowlingTopWickeTakers } = await queryGraphql(STATS, {
            input: { iSeriesId: idData?.getSeoData?.iId, _id: bowlingTopWickeTakers._id }
          })
          const bowlingBestEconomy = seriesData.fetchSeriesStatsTypes.find(obj => obj.sType === 'bowling_best_economy_rates')
          const { data: statsDataBowlingBestEconomy } = await queryGraphql(STATS, {
            input: { iSeriesId: idData?.getSeoData?.iId, _id: bowlingBestEconomy._id }
          })
          const bowlingBestAverages = seriesData.fetchSeriesStatsTypes.find(obj => obj.sType === 'bowling_best_averages')
          const { data: statsDataBowlingBestAverages } = await queryGraphql(STATS, {
            input: { iSeriesId: idData?.getSeoData?.iId, _id: bowlingBestAverages._id }
          })
          return {
            props: {
              seoData: idData?.getSeoData,
              seriesData: seriesData,
              statsData: statsData,
              seriesHeaderData: seriesHeaderData?.getSeriesByIdFront,
              type: currentPage,
              scoreCard: scoreCard?.listSeriesScorecard,
              subPages: subPages?.getSeosBySlug,
              currentSeriesData: currentSeriesData,
              statsDataBattingMostRuns: statsDataBattingMostRuns,
              statsDataBattingHighestStrikerate: statsDataBattingHighestStrikerate,
              statsDataBattingHighestAverage: statsDataBattingHighestAverage,
              statsDataBowlingTopWickeTakers: statsDataBowlingTopWickeTakers,
              statsDataBowlingBestEconomy: statsDataBowlingBestEconomy,
              statsDataBowlingBestAverages: statsDataBowlingBestAverages
            }
          }
        }
      } else if (currentPage === 'teams') {
        const { data: seriesTeamData } = await queryGraphql(LIST_SERIES_TEAMS, { input: { iSeriesId: idData?.getSeoData?.iId } })
        return {
          props: {
            seoData: idData?.getSeoData,
            seriesTeamData: seriesTeamData,
            seriesHeaderData: seriesHeaderData?.getSeriesByIdFront,
            type: currentPage,
            scoreCard: scoreCard?.listSeriesScorecard,
            subPages: subPages?.getSeosBySlug,
            currentSeriesData: currentSeriesData,
            rankingTabData: rankingTabData
          }
        }
      } else if (currentPage === 'fantasy-tips') {
        const { data: seriesFantasyTipsData } = await queryGraphql(LIST_SERIES_FANTASY_TIPS, {
          input: { iSeriesId: idData?.getSeoData?.iId, nOrder: -1, sSortBy: 'dStartDate' }
        })
        return {
          props: {
            seoData: idData?.getSeoData,
            seriesFantasyTipsData: seriesFantasyTipsData,
            seriesHeaderData: seriesHeaderData?.getSeriesByIdFront,
            type: currentPage,
            scoreCard: scoreCard?.listSeriesScorecard,
            subPages: subPages?.getSeosBySlug,
            currentSeriesData: currentSeriesData,
            rankingTabData: rankingTabData
          }
        }
      } else if (currentPage === 'squads') {
        const { data: seriesTeamData } = await queryGraphql(LIST_SERIES_TEAMS, { input: { iSeriesId: idData?.getSeoData?.iId } })
        if (seriesTeamData?.listSeriesTeams?.aTeams?.length) {
          const iTeamId = query?.teamid || seriesTeamData?.listSeriesTeams?.aTeams[0]?._id
          const { data: teamPlayer } = await queryGraphql(GET_TEAM_PLAYER, { input: { iSeriesId: idData?.getSeoData?.iId, iTeamId } })
          return {
            props: {
              seoData: idData?.getSeoData,
              seriesTeamData: seriesTeamData,
              seriesHeaderData: seriesHeaderData?.getSeriesByIdFront,
              teamPlayer: teamPlayer?.listSeriesSquad,
              type: currentPage,
              scoreCard: scoreCard?.listSeriesScorecard,
              subPages: subPages?.getSeosBySlug,
              currentSeriesData: currentSeriesData,
              rankingTabData: rankingTabData
            }
          }
        } else {
          return {
            props: {
              seoData: idData?.getSeoData,
              seriesTeamData: seriesTeamData,
              seriesHeaderData: seriesHeaderData?.getSeriesByIdFront,
              type: currentPage,
              scoreCard: scoreCard?.listSeriesScorecard,
              subPages: subPages?.getSeosBySlug,
              currentSeriesData: currentSeriesData,
              rankingTabData: rankingTabData
            }
          }
        }
      } else {
        const [fixturesData, teamData] = await parallelCalls([
          queryGraphql(FIXTURES_LIST, {
            input: { iSeriesId: idData?.getSeoData?.iId, nOrder: 1, sSortBy: 'dStartDate' }
          }),
          queryGraphql(FETCH_TEAM_VENUE, { input: { iSeriesId: idData?.getSeoData?.iId } })
        ])

        return {
          props: {
            seoData: idData?.getSeoData,
            fixturesData: fixturesData,
            seriesHeaderData: seriesHeaderData?.getSeriesByIdFront,
            fixturesFilter: teamData,
            scoreCard: scoreCard?.listSeriesScorecard,
            subPages: subPages?.getSeosBySlug,
            currentSeriesData: currentSeriesData,
            rankingTabData: rankingTabData
          }
        }
      }
    } else if (idData?.getSeoData?.eType === 'ct') {
      // For series category
      const getCategorySSRData = (await import('@shared/libs/category')).getCategorySSRData

      if (currentPage === 'standings') res.setHeader('Cache-Control', 'public, max-age=120, s-maxage=120')
      else res.setHeader('Cache-Control', 'public, max-age=420')

      const value = await getCategorySSRData(idData?.getSeoData, currentPage, false, {}, resolvedUrl)
      if (value?.notFound) return value
      return {
        props: {
          seoData: idData?.getSeoData,
          category: value,
          currentSeriesData: currentSeriesData
        }
      }
    }
    return { notFound: true }
  } catch (e) {
    console.log({ e })
    res.setHeader('Cache-Control', 'no-cache')
    // return { props: { error: JSON.stringify(e) } }
    const status = handleApiError(e, resolvedUrl)
    return status
  }
}
